// extracted by mini-css-extract-plugin
export var container = "_4f-0";
export var disabled = "_4f-4";
export var fullWidth = "_4f-3";
export var lined = "_4f-1";
export var selected = "_4f-5";
export var tab = "_4f-2";